import { useEffect, useState } from "react";
import {
  fundraisingCampaignRoutes,
  type FundraisingCampaignListResponse,
} from "@/services/fundraising-campaigns";
import useSWR from "swr";
import { fetcherV2 } from "@gogive/services";

interface Props {
  initialPage: number;
  limit: number;
}

export function useFundraisingCampaigns({ initialPage, limit }: Props) {
  const [page, setPage] = useState<number>(initialPage);
  const [pages, setPages] = useState<number>(0);

  const { data, error, mutate, isLoading } = useSWR(
    () => [fundraisingCampaignRoutes.list, { page, limit }],
    fetcherV2<FundraisingCampaignListResponse>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  useEffect(() => {
    if (data && !isLoading) {
      setPages(data.pages);
    }
  }, [data, isLoading]);

  return {
    campaigns: data?.rows ?? [],
    refresh: mutate,
    total: data?.total ?? 0,
    page: page + 1,
    pages,
    next: () => setPage((p) => p + 1),
    previous: () => setPage((p) => p - 1),
    canPrevious: page > 0,
    canNext: page + 1 < pages,
    isLoading: !error && !data,
    isError: error,
    pageSize: limit,
  };
}
